export default __webpack_public_path__ + "static/water-stones-4c31daa7bad501ff31bfacbf0b8f7f95.png";